module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#gallery",
      toString: function () {
        return this.url;
      }
    }